import { Injectable } from "@angular/core";
import { AuthenticationConstants } from "../constants";

@Injectable({
  providedIn: 'root',
})
export class AuthenticationLocalStorageService {


  isUserLoggedIn(): boolean {
    let userToken = localStorage.getItem(AuthenticationConstants.USER_TOKEN);
    let userExpiresAt = localStorage.getItem(AuthenticationConstants.USER_EXPIRES_AT);

    if (userToken && userExpiresAt && new Date() < new Date(userExpiresAt)) {
      return true;
    }
    else {
      return false;
    }
  }

  isApplicantLoggedIn(): boolean {

    const applicantToken = localStorage.getItem(AuthenticationConstants.APPLICANT_TOKEN);
    const applicantExpiresAt = localStorage.getItem(AuthenticationConstants.APPLICANT_EXPIRES_AT);

    if (applicantToken && applicantExpiresAt && new Date() < new Date(applicantExpiresAt)) {
      return true;
    }
    else {
      return false;
    }
  }
}
